module.exports = __webpack_public_path__ + "png/payment-way4.png?9fc626dc5221edccc64153c6b026cc37";